export default {
  // UPDATE ADDRESS
  "update-address_page-title": "Update Address",
  "update-address_page-description": "Enter your temporary PIN below and then use the form to update your address.",
  "update-address_form-label_auth-token": "Authorization Token",
  "update-address_form-label_non-us-address": "Non-US Address",
  "___update-address_form-label_addr-1": "",
  "___update-address_form-label_addr-2": "",
  "___update-address_form-label_non-us-addr-1": "Non US Address Line 1",
  "___update-address_form-label_non-us-addr-2": "Non US Address Line 2",
  "___update-address_form-label_non-us-addr-3": "Non US Address Line 3",
  "___update-address_form-label_city": "",
  "___update-address_form-label_state": "",
  "___update-address_form-label_zip": "",
  "___update-phone_form-hint_zip": "",
  "update-address_action_submit": "Save Changes",
  "update-address_form-error_addr-1_required": "Address line 1 is required",
  "update-address_form-error_addr-1_max-length": "Address line 1 must be %maxLength% characters or fewer",
  "update-address_form-error_addr-2_max-length": "Address line 2 must be %maxLength% characters or fewer",
  "update-address_form-error_city_required": "City is required",
  "update-address_form-error_city_max-length": "City must be %maxLength% characters or fewer",
  "___update-address_form-error_state_required": "",
  "___update-address_form-error_zip_required": "",
  "update-address-error_zip_invalid-format": "The Zip Code must contain 5 or 9 digits.",
  "update-address_form-error_non-us-addr-1_required": "Address line 1 is required",
  "update-address_form-error_non-us-addr-1_max-length": "Address line 1 must be %maxLength% characters or fewer",
  "update-address_form-error_non-us-addr-2_max-length": "Address line 2 must be %maxLength% characters or fewer",
  "update-address_form-error_non-us-addr-3_required": "Address line 3 is required",
  "update-address_form-error_non-us-addr-3_max-length": "Address line 3 must be %maxLength% characters or fewer",
  "update-address_submit_text_loading-message": "Saving Address…",
  "update-address_text_enter-complete-address": "No address matches found. Please enter a complete address.",
  "___update-address_title_confirm-close": "",
  "___update-address_text_confirm-close": "",
  "___update-address_action_confirm-close_cancel": "",
  "___update-address_action_confirm-close_confirm": "",
  "___update-address_action_done": "",
  "update-address_text_refresh-data-error-message": "Your address has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // UPDATE EMAIL
  "update-email_page-title": "Update Email",
  "update-email_page-description": "Enter your temporary PIN below and then use the form to update your email address.",
  "update-email_action_submit": "Save Changes",
  "___update-email_action_done": "",
  "___update-email_title_confirm-close": "",
  "___update-email_text_confirm-close": "",
  "___update-email_action_confirm-close_cancel": "",
  "___update-email_action_confirm-close_confirm": "",
  "___update-email_form-label_email": "",
  "___update-email_form-error_email_required": "",
  "___update-email_form-error_email_invalid-format": "",
  "update-email_form-error_email_length": "Email cannot be longer than %maxLength% characters.",
  "update-email_form-error_existing_email": "This email address already exists. Please try again.",
  "update-email_form-label_confirm-email": "Confirm Email",
  "___update-email_form-error_confirm-email_required": "",
  "update-email_form-error_confirm-email_same-as": "The Email Addresses entered do not match",
  "update-email_submit_text_loading-message": "Saving Email…",
  "update-email_submit_text_success-message": "Update Email Success",
  "update-email_submit_text_error-message": "Update Email Error",
  "update-email_text_refresh-data-error-message": "Your email has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // UPDATE PHONE
  "update-phone_page-title": "Update Phone",
  "update-phone_page-description": "Enter your temporary PIN below and then use the form to update your phone number.",
  "update-phone_action_submit": "Save Changes",
  "___update-phone_action_done": "",
  "___update-phone_title_confirm-close": "",
  "___update-phone_text_confirm-close": "",
  "___update-phone_action_confirm-close_cancel": "",
  "___update-phone_action_confirm-close_confirm": "",
  "update-phone_form-label_primary-phone": "Primary",
  "___update-phone_form-label_primary-phone-mobile": "",
  "update-phone_form-label_alt-phone": "Alternate",
  "___update-phone_form-label_alt-phone-mobile": "",
  "update-phone_form-label_phone-mobile": "Check if this is a mobile number",
  "update-phone_form-error_primary-phone_required": "Primary phone number is required",
  "update-phone_form-error_primary-phone_invalid-format": "Invalid Primary Phone Number",
  "update-phone_form-error_primary-phone_invalid-length": "Invalid Primary Phone Number Length",
  "___update-phone_form-hint_phone": "",
  "update-phone_form-error_alt-phone_required": "Alternate phone number is required",
  "update-phone_form-error_alt-phone_invalid-format": "Invalid Alternate Phone Number",
  "update-phone_form-error_alt-phone_invalid-length": "Invalid Alternate Phone Number Length",
  "update-phone_text_loading-message": "Saving Phone Number…",
  "update-phone_text_success-message": "Update Phone Number Success",
  "update-phone_text_error-message": "Update Phone Number Error",
  "update-phone_text_refresh-data-error-message": "Your phone number has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // UPDATE PASSWORD
  "update-password_page-title": "Update Password",
  "update-password_page-description": "Enter your temporary PIN below and then use the form to change your password.",
  "update-password-history": 'Must be different from previous passwords you have used',
  "update-password-name": 'Must not contain your username, first or last name',
};